const formatDate = (datetime) => {
  const day = datetime.substr(8, 2);
  const month = datetime.substr(5, 2);
  const year = datetime.substr(0, 4);
  return `${day}.${month}.${year}`;
};

export default formatDate;
